
import { computed, defineComponent, PropType, toRefs } from 'vue';
import { GenreStyleModel } from '@/typings';
import { StyleTag } from '@/components/common';

import markdown from '@/markdown/renderMD';

export default defineComponent({
    components: {
        StyleTag
    },
    props: {
        info: {
            type: Object as PropType<GenreStyleModel>,
            required: true
        },
        childs: {
            type: Array as PropType<GenreStyleModel[]>,
            required: true
        }
    },
    setup (props) {
        const {
            childs
        } = toRefs(props);

        const showChilds = computed(() => childs.value.filter(item => item.show_in_list));

        return {
            markdown,
            showChilds
        };
    }
});

